/* ==========================================================================
   CREALUX — CORRECTIFS AUDIT (JS)
   Ajout rapide au panier depuis les collections + feedback du bouton.
   ========================================================================== */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 2
      });
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  // Rafraîchit le compteur du panier dans l'en-tete
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { return null; });
  }

  // Ajout rapide : un seul variant disponible, pas d'options
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-quick-add]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.disabled) return;

    var id = btn.getAttribute('data-quick-add');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-done');
        btn.textContent = 'Ajouté ✓';
        return refreshCount();
      })
      .then(function () {
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = label;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.textContent = 'Erreur';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      });
  });

  // Bandeau d'annonce : rotation douce des messages
  (function announcement() {
    var box = document.querySelector('[data-lx-announce]');
    if (!box) return;
    var items = box.querySelectorAll('.lx-announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 5000);
  })();

  // Barre de progression du panier : ne bouge pas toute seule, elle est
  // rendue cote serveur (Liquid). Ici on ne fait qu'animer le remplissage.
  (function progress() {
    var fill = document.querySelector('[data-cart-progress-fill]');
    if (!fill) return;
    var target = fill.getAttribute('data-width') || '0';
    fill.style.width = '0%';
    requestAnimationFrame(function () {
      setTimeout(function () { fill.style.width = target + '%'; }, 120);
    });
  })();

  // Fermeture du bandeau d'annonce (memorise pour la session)
  (function announceClose() {
    var btn = document.querySelector('[data-lx-announce-close]');
    if (!btn) return;
    try { if (sessionStorage.getItem('lx-announce-off') === '1') { btn.closest('.lx-announce').remove(); return; } } catch (e) {}
    btn.addEventListener('click', function () {
      var el = btn.closest('.lx-announce');
      if (el) el.remove();
      try { sessionStorage.setItem('lx-announce-off', '1'); } catch (e) {}
    });
  })();
})();
